import client from './client'

export default {
  async getGroupChat (id) {
    let url = `/groupChat/${id}`
    const res = await client.get(url)
    return res && res.data && res.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/groupChat.js